const determineSubnet = (ipAddress) => {
    if (!ipAddress || typeof ipAddress !== 'string') return '';

    const parts = ipAddress.split('.');
    if (parts.length < 3) return '';

    const subnetId = parts.slice(0, 3).join('.');
    const subnetMap = {
        '192.168.1': 'Subnet1',
        '192.168.2': 'Subnet2',
        '192.168.3': 'Subnet3',
        '10.20.30': 'Subnet0',
    };

    return subnetMap[subnetId] || 'unknown';
};


export default determineSubnet;